import { useLiveConsultStore } from "@/App/components/liveConsult/liveConsult.store";
import { useCasesStore } from "@/Pages/Cases/store";
import router from "@/App/router/router";
import type { RouteLocationRaw } from "vue-router";
import { toRaw } from "vue";
import { showEndLiveConsultModal } from "@/App/components/liveConsult/showEndLiveConsultModal";

let approvedRoute: RouteLocationRaw = "";

export const checkForOngoingLiveConsult = (to: { path: RouteLocationRaw }): boolean => {
  const casesStore = useCasesStore();
  const liveConsultStore = useLiveConsultStore();

  if (approvedRoute === to.path) {
    approvedRoute = "";

    return true;
  }

  if (casesStore.selectedCaseId && liveConsultStore.liveConsultOn[casesStore.selectedCaseId]) {
    const onConfirm = async (): Promise<void> => {
      approvedRoute = to.path;

      if (casesStore.selectedCaseId) {
        liveConsultStore.liveConsultOn[casesStore.selectedCaseId] = false;

        toRaw(liveConsultStore.startedLiveConsults[casesStore.selectedCaseId]).hangUp();
      }

      await router.push(to.path);
    };

    showEndLiveConsultModal(onConfirm);

    return false;
  }

  return true;
};
